module.exports = __webpack_public_path__ + "media/images/new-share-icon-5389a9432ee3214f854eb406ce137898.png";